var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionalInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.614014 1.59651L0.614014 12.4035C0.614014 12.9461 1.05387 13.386 1.59647 13.386H12.4035C12.9461 13.386 13.3859 12.9461 13.3859 12.4035V1.59651C13.3859 1.05392 12.9461 0.614057 12.4035 0.614057H1.59647C1.05387 0.614057 0.614014 1.05392 0.614014 1.59651Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54395 10.9299V6.01758",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54375 6.01744C5.35765 6.01744 6.01744 5.35765 6.01744 4.54375C6.01744 3.72986 5.35765 3.07007 4.54375 3.07007C3.72986 3.07007 3.07007 3.72986 3.07007 4.54375C3.07007 5.35765 3.72986 6.01744 4.54375 6.01744Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45605 3.07007V6.01744",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45605 8.96484V10.9298",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45611 8.96495C10.27 8.96495 10.9298 8.30516 10.9298 7.49126C10.9298 6.67737 10.27 6.01758 9.45611 6.01758C8.64221 6.01758 7.98242 6.67737 7.98242 7.49126C7.98242 8.30516 8.64221 8.96495 9.45611 8.96495Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfo);
export default __webpack_public_path__ + "static/media/additionalInfo.f7348333a0028a3539e4d20df3bb6eba.svg";
export { ForwardRef as ReactComponent };